import { Injectable } from '@angular/core';
import { LandingHero, PromoBanner } from '@box-types';
import { PromoBannersService, ConfigurationService } from '@box-core/services';
import { isEnabledByTimeRanges, generateImageSrc } from '@box/utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalStateService } from '@box-core/services/global-state.service';

@Injectable()
export class LandingHeroService {
  constructor(
    private configurationService: ConfigurationService,
    private promoBannersService: PromoBannersService,
    private globalStateService: GlobalStateService
  ) {}

  public getActiveLandingHero(): LandingHero {
    const landingHeroData = this.configurationService.getConfiguration().webLandingHeroes;
    if (!landingHeroData?.length) return;
    const activeHero = landingHeroData.find((data) => isEnabledByTimeRanges(data.enabledOnTimeRanges));
    return activeHero ?? landingHeroData[0];
  }

  public getLandingHeroImageSrc(landingHero: LandingHero, key: string): string {
    if (!landingHero?.images) return;
    const image = landingHero.images[key];
    if (!image) return;
    return generateImageSrc(image);
  }

  public getPromoBanner(): Observable<PromoBanner> {
    return this.globalStateService.promoBanners$.pipe(
      map((promoBanners) => this.promoBannersService.getLandingPromoBanner(promoBanners))
    );
  }
}
